import type { FC, PropsWithChildren } from 'react';
import { SiteMetadataProvider } from '@anywayseo/tools';

import { useExpertImageQuery, useGamePreviewImageQuery, useLogoImageQuery, useSiteMetadata } from 'hooks';


const PageWrapper: FC<PropsWithChildren> = ({ children }) => {
  const siteMetadata = useSiteMetadata();
  const gamePreviewImageData = useGamePreviewImageQuery();
  const expertImageData = useExpertImageQuery();
  const logoImageData = useLogoImageQuery();

  return (
    <SiteMetadataProvider
      siteMetadata={siteMetadata}
      logoImageData={logoImageData}
      expertImageData={expertImageData}
      gamePreviewImageData={gamePreviewImageData}
    >
      {children}
    </SiteMetadataProvider>
  );
};

export default PageWrapper;
